var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#0088FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.552 15.5V14.264L9.976 11.732C10.456 11.228 10.824 10.828 11.08 10.532C11.344 10.228 11.528 9.968 11.632 9.752C11.736 9.536 11.788 9.316 11.788 9.092C11.788 8.716 11.668 8.42 11.428 8.204C11.196 7.988 10.896 7.88 10.528 7.88C10.144 7.88 9.812 7.992 9.532 8.216C9.252 8.432 9.048 8.752 8.92 9.176L7.492 8.732C7.588 8.26 7.784 7.852 8.08 7.508C8.376 7.156 8.736 6.888 9.16 6.704C9.592 6.512 10.048 6.416 10.528 6.416C11.104 6.416 11.608 6.52 12.04 6.728C12.48 6.936 12.82 7.228 13.06 7.604C13.308 7.98 13.432 8.42 13.432 8.924C13.432 9.244 13.372 9.56 13.252 9.872C13.132 10.184 12.952 10.504 12.712 10.832C12.472 11.152 12.16 11.512 11.776 11.912L9.676 14.12H13.552V15.5H7.552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/number2.bd5781e3e13cf837e7e02796bedd750a.svg";
export { ForwardRef as ReactComponent };